import { render, staticRenderFns } from "./MainNavMenu.vue?vue&type=template&id=34ef715a"
import script from "./MainNavMenu.vue?vue&type=script&lang=js"
export * from "./MainNavMenu.vue?vue&type=script&lang=js"
import style0 from "./MainNavMenu.vue?vue&type=style&index=0&id=34ef715a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports